/*
    TODO: как правильно типизировать такую функцию?
*/
export function arrayEquals(a: unknown[], b: unknown[]): boolean {
    return a.length === b.length && a.every((val, index) => val === b[index]);
}
